// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__30SnE","sendOtp":"AuthorizeToLogin_sendOtp__nDZxq"};